exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Ks9C468NuGBKKulj2wyP3{color:var(--neutralSecondary);-webkit-user-select:all;-moz-user-select:all;-ms-user-select:all;user-select:all;text-decoration:underline}html[dir] ._2Ks9C468NuGBKKulj2wyP3{padding:0 1px;border-radius:2px}._3jYnsiE1L-hEGGfCHeSp0p{vertical-align:middle;width:14px;height:14px;display:inline-block}html[dir=ltr] ._3jYnsiE1L-hEGGfCHeSp0p{padding-left:1px;padding-right:2px}html[dir=rtl] ._3jYnsiE1L-hEGGfCHeSp0p{padding-right:1px;padding-left:2px}._1pJ76cb6L3I_chHGU0U5nA{display:none}", ""]);
// Exports
exports.locals = {
	"placeholder": "_2Ks9C468NuGBKKulj2wyP3",
	"linkSpinner": "_3jYnsiE1L-hEGGfCHeSp0p",
	"hidden": "_1pJ76cb6L3I_chHGU0U5nA"
};